<template>
  <div class="container" style="height:100%;z-index:1" fill-height>
    <form-loader :form="this.form" @load="handleLoginFormLoaded" />
  </div>
</template>

<script>
export default {
  name: 'FormPage',
  props: {
    form: {
      type: String,
      required: true
    }
  },
  methods: {
    handleLoginFormLoaded(form$) {}
  }
}
</script>
